import { Extension } from '@tiptap/core';
import * as commands from './commands';
import { getParentByAttribute } from '../helpers/getParentByAttribute';

export const NudgeSuggestion = Extension.create({
  name: 'nudgeSuggestion',

  addCommands() {
    return {
      setNudges: commands.setNudges.bind(this),
      addNudge: commands.addNudge.bind(this),
      removeAllNudges: commands.removeAllNudges.bind(this),
      insertNudgeSuggestion: commands.insertNudgeSuggestion.bind(this),
    };
  },

  onCreate() {
    const attr = 'data-nudge-id';
    const findId = (el) => getParentByAttribute(el, attr)?.getAttribute(attr) || '';

    this.editor.view.dom.addEventListener('mouseover', (event) => {
      if (event.buttons) {
        return;
      }

      if (!event.target.classList.contains('nudge-icon')) {
        return;
      }

      const id = findId(event.target);
      if (id && !this.storage.nudges[id]?.hide) {
        this.options.onMouseOver({ id, event, tiptap: this.editor });
      }
    });

    this.editor.view.dom.addEventListener('mouseout', (event) => {
      const id = findId(event.target);
      if (!event.target.classList.contains('nudge-icon')) {
        return;
      }
      if (id) {
        this.options.onMouseOut({ id, event, tiptap: this.editor });
      }
    });
  },

  addOptions() {
    return {
      onMouseOver: () => null,
      onMouseOut: () => null,
    };
  },

  addStorage() {
    return { nudges: {} };
  },
});

export const addNudgeIdAttribute = (BaseClass) => BaseClass.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      nudgeId: {
        default: null,
        renderHTML: ({ nudgeId }) => ({ 'data-nudge-id': nudgeId }),
      },
      severity: {
        default: null,
        renderHTML: ({ severity }) => ({ 'data-nudge-severity': severity }),
      },
      count: {
        default: null,
        renderHTML: ({ count }) => ({ 'data-nudge-count': count }),
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const {
      'data-nudge-id': nudgeId,
      'data-nudge-severity': severity,
      'data-nudge-count': count,
      ...attrs
    } = HTMLAttributes;

    if (!nudgeId) {
      return this.parent({ node, HTMLAttributes });
    }

    return [
      'div',
      { 'data-nudge-id': nudgeId, class: 'has-nudge' },
      ['div', {
        'data-nudge-count': count,
        class: `nudge-icon nudge-${severity}`,
      }],
      this.parent({ node, HTMLAttributes: attrs }),
    ];
  },
});
